import script from "./DropdownToggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropdownToggle.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__